import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ColorPaletteIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M3 12.5C3 7.5 6 3.5 12 3.5C19 3.5 23 10.5 20.9 14.6C19.17 17.98 15 14.6 13 16.5C11 18.4 14 19.5 12 20.5C10 21.5 3 20.5 3 12.5Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeMiterlimit="10"
      />
      <path
        d="M17.75 12.5C18.1642 12.5 18.5 12.1642 18.5 11.75C18.5 11.3358 18.1642 11 17.75 11C17.3358 11 17 11.3358 17 11.75C17 12.1642 17.3358 12.5 17.75 12.5Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeMiterlimit="10"
      />
      <path
        d="M14.75 9.5C15.1642 9.5 15.5 9.16421 15.5 8.75C15.5 8.33579 15.1642 8 14.75 8C14.3358 8 14 8.33579 14 8.75C14 9.16421 14.3358 9.5 14.75 9.5Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeMiterlimit="10"
      />
      <path
        d="M10.25 8.5C10.6642 8.5 11 8.16421 11 7.75C11 7.33579 10.6642 7 10.25 7C9.83579 7 9.5 7.33579 9.5 7.75C9.5 8.16421 9.83579 8.5 10.25 8.5Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeMiterlimit="10"
      />
      <path
        d="M6.75 11.5C7.16421 11.5 7.5 11.1642 7.5 10.75C7.5 10.3358 7.16421 10 6.75 10C6.33579 10 6 10.3358 6 10.75C6 11.1642 6.33579 11.5 6.75 11.5Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeMiterlimit="10"
      />
    </BaseIcon>
  ),
);

ColorPaletteIcon.displayName = 'ColorPaletteIcon';
